import objectPath from "object-path";
import ApiService from "@/common/api.service";
import config from "@/common/config/layout.config.json";

// action types
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";
export const SET_APP_SECTION = "setSection";
export const LOAD_APP_CONFIG = "loadAppConfig";

// mutation types

export default {
  state: {
    config: config,
    section: "default",
    appConfig: null
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: state => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    getSection: state => state.section,
    /**
     * Get config from app config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    getConfig: state => (path, defaultValue) => {
      if (state.appConfig == null) {
        return null;
      }

      return objectPath.get(state.appConfig, path, defaultValue);
    },
    appConfigLoaded: state => {
      return state.appConfig !== null;
    }
  },
  actions: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG);
    },
    [SET_APP_SECTION](state, payload) {
      state.commit(SET_APP_SECTION, payload);
    },
    [LOAD_APP_CONFIG](context, payload) {
      // console.log(context);
      var url = payload ? `configurations/${payload}` : "configurations";

      return new Promise((resolve, reject) => {
        ApiService.get(url)
          .then(({ data }) => {
            context.commit(LOAD_APP_CONFIG, data.data);
            resolve(data.data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    }
  },
  mutations: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = Object.assign(
        {},
        state.config,
        JSON.parse(localStorage.getItem("config"))
      );
    },
    [SET_APP_SECTION](state, payload) {
      state.section = payload;
    },
    [LOAD_APP_CONFIG](state, payload) {
      state.appConfig = payload;
    }
  }
};
